import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import {StorageUnit} from "components/core/Icons"

import "./OMIBanner.scss";

export default function OMIBanner({ className }) {
	return (
		<div className={classnames("omi-banner", className)}>
			<div className="omi-banner-content">
				<StorageUnit />
				<span className="omi-banner-text">Online Move-In Available</span>
			</div>
		</div>
	);
}

OMIBanner.propTypes = {
	className: PropTypes.string,
};
